import { Link } from 'react-router-dom';
import logo from '@/assets/logo.webp';
import seuroboLogo from '@/assets/seurobo-logo.webp';

export function Footer() {
  return (
    <footer className="border-t border-border/50 bg-card/50">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center mb-4">
              <img src={logo} alt="PromptCodex" width={188} height={32} className="h-8 w-auto" loading="lazy" decoding="async" />
            </Link>
            <p className="text-muted-foreground text-sm">
              Transforme suas ideias em prompts otimizados. A ponte entre você e todas as IAs generativas.
            </p>
          </div>

          {/* Product */}
          <div>
            <h2 className="font-semibold mb-4 text-base">Produto</h2>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/#como-funciona" className="hover:text-foreground transition-colors">Como Funciona</Link></li>
              <li><Link to="/#precos" className="hover:text-foreground transition-colors">Preços</Link></li>
              <li><Link to="/generate" className="hover:text-foreground transition-colors">Gerar Prompt</Link></li>
              {/* TODO: Add API docs link in future */}
              <li><span className="opacity-50">API (em breve)</span></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h2 className="font-semibold mb-4 text-base">Recursos</h2>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/faq" className="hover:text-foreground transition-colors">Perguntas Frequentes</Link></li>
              <li><Link to="/suporte" className="hover:text-foreground transition-colors">Suporte</Link></li>
              <li><span className="opacity-50">Blog (em breve)</span></li>
              <li><span className="opacity-50">Guias de Prompts (em breve)</span></li>
              <li><span className="opacity-50">Casos de Uso (em breve)</span></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h2 className="font-semibold mb-4 text-base">Legal</h2>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {/* TODO: Create actual legal pages */}
              <li><Link to="/termos" className="hover:text-foreground transition-colors">Termos de Uso</Link></li>
              <li><Link to="/privacidade" className="hover:text-foreground transition-colors">Política de Privacidade</Link></li>
              <li><Link to="/cookies" className="hover:text-foreground transition-colors">Política de Cookies</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border/50 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} PromptCodex. Todos os direitos reservados.
          </p>
          <a
            href="https://seurobo.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm text-muted-foreground/60 hover:text-muted-foreground transition-colors"
          >
            Developed by
            <img src={seuroboLogo} alt="SeuRobô" width={50} height={24} loading="lazy" decoding="async" className="h-6 w-auto opacity-60 hover:opacity-100 transition-opacity" />
          </a>
        </div>
      </div>
    </footer>
  );
}
